import React, { Component } from "react";
import {
  DataGrid,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label, GroupItem } from "devextreme-react/form";
import { Button } from "devextreme-react";
import PaginaToolbar from "../components/PaginaToolbar";
import {} from "../DataSources";
import uiInfo from "../ui-info";
import { anoOptions, mesOptions } from "../utils/date-utils";

export default class NfseBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroCorrente: [],
      filtro: {},
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.nfseDs = [];

    this.retidaOptions = {
      dataSource: ["Sim", "Não"],
      placeholder: "Selecione...",
    };

    this.situacao = [
      { id: 0, descricao: "Tributada no Município" },
      { id: 1, descricao: "Tributada Fora do Município" },
      { id: 2, descricao: "Isenta" },
      { id: 3, descricao: "Imune" },
      { id: 4, descricao: "Exibilidade Suspensa por Decisão Judicial" },
      { id: 5, descricao: "Exibilidade Suspensa por Processo Administrativo" },
    ];

    this.situacaoOptions = {
      dataSource: this.situacao,
      displayExpr: "descricao",
      valueExpr: "id",
    };

    this.status = [
      { id: 0, descricao: "ABERTA" },
      { id: 1, descricao: "FECHADA" },
      { id: 2, descricao: "CANCELADA" },
    ];
    this.statusOptions = {
      dataSource: this.status,
      placeholder: "Selecione...",
      displayExpr: "descricao",
      valueExpr: "id",
    };
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];

    if (filtro.id !== undefined) {
      filtroCorrente.push(["id", "contains", filtro.id.trim()]);
    }
    if (filtro.descricao !== undefined) {
      filtroCorrente.push(["descricao", "contains", filtro.descricao.trim()]);
    }
    if (filtro.receitaId !== undefined) {
      filtroCorrente.push(["receitaId", "contains", filtro.receitaId.trim()]);
    }

    this._gridInstance.instance.filter(filtroCorrente);
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="filtro-form"
            formData={this.state.filtro}
            colCount={6}
            labelLocation="top"
          >
            <GroupItem colCount={6} colSpan={6}>
              <SimpleItem
                dataField="dataInicial"
                editorType="dxDateBox"
                editorOptions={{ displayFormat: "dd/MM/yyyy", width: "100%", useMaskBehavior: true }}
              >
                <Label text="Data Inicial" />
              </SimpleItem>

              <SimpleItem
                dataField="dataFinal"
                editorType="dxDateBox"
                editorOptions={{ displayFormat: "dd/MM/yyyy", width: "100%", useMaskBehavior: true }}
              >
                <Label text="Data Final" />
              </SimpleItem>

              <SimpleItem colSpan={2} dataField="nome">
                <Label text="Nome" />
              </SimpleItem>

              <SimpleItem colSpan={2} dataField="cpfCnpj">
                <Label text="CPF ou CNPJ" />
              </SimpleItem>

              <SimpleItem dataField="numero">
                <Label text="Número" />
              </SimpleItem>

              <SimpleItem dataField="nmeroRps">
                <Label text="Número RPS" />
              </SimpleItem>

              <SimpleItem
                colSpan={2}
                dataField="situacaoNota"
                editorType="dxSelectBox"
                editorOptions={this.situacaoOptions}
              >
                <Label text="Situação da Nota" />
              </SimpleItem>

              <SimpleItem
                colSpan={1}
                dataField="retida"
                editorType="dxSelectBox"
                editorOptions={this.retidaOptions}
              >
                <Label text="Retida" />
              </SimpleItem>

              <SimpleItem
                colSpan={1}
                dataField="statusNota"
                editorType="dxSelectBox"
                editorOptions={this.statusOptions}
              >
                <Label text="Status da Nota" />
              </SimpleItem>

              <SimpleItem
                dataField="mesCompetencia"
                editorType="dxSelectBox"
                editorOptions={mesOptions}
              >
                <Label text="Mês Competência" />
              </SimpleItem>

              <SimpleItem
                dataField="anoCompetencia"
                editorType="dxSelectBox"
                editorOptions={anoOptions}
              >
                <Label text="Ano Competência" />
              </SimpleItem>

              <SimpleItem colSpan={2} dataField="situacaoTomador">
                <Label text="Situação no Tomador" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <br />
        <PaginaToolbar titulo="Taxas">
          <DataGrid
            dataSource={this.nfseDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
          >
            <Editing
              allowDeleting={false}
              allowUpdating={false}
              useIcons={true}
              visible={false}
            />
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              visible={this.usadoComoPesquisa}
              buttons={[
                {
                  hint: "Selecionar",
                  icon: "repeat",
                  visible: this.usadoComoPesquisa,
                  onClick: this.onSelecionado,
                },
              ]}
            />
            <Column
              dataField={"id"}
              allowEditing={false}
              caption={"#"}
              visible={false}
              width={80}
            />
            <Column
              dataField={"numero"}
              visibleIndex={0}
              alignment="center"
              allowEditing={false}
              caption={"Nº"}
              width={80}
            />

            <Column
              dataField={"dataEmissao"}
              dataType={"date"}
              caption={"Emissão"}
            />
            <Column dataField={"tomadorCpfCnpj"} caption={"Doc. Tomador"} />
            <Column dataField={"tomadorNome"} caption={"Nome Tomador"} />
            <Column dataField={"valorServicos"} caption={"Valor"} />
            <Column dataField={"situacao"} caption={"Situação"}>
              <Lookup
                dataSource={this.situacao}
                displayExpr={"descricao"}
                valueExpr={"id"}
              />
            </Column>
            <Column
              dataField={"valorIss"}
              caption={"Valor ISS"}
              customizeText={(cellInfo) => "R$" + cellInfo.value}
            />
            <Column
              dataField={"issRetido"}
              caption={"Retida"}
              customizeText={(cellInfo) => (cellInfo.value ? "Sim" : "Não")}
              dataType="text"
            />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }
}
